<template lang="pug">
global-form-group(
    :title="field.title"
    :show-label="showLabel"
    :field-name="field.name"
    :class="{'nse-input-error': error_require}"
)

    input(:value="placeSearch" type="text" ref="placeSearch" @blur="validPlace" @input="searchMap")

    div.list-place-loading
        div.suggestion-place()
            template(v-if="loadingAjax")
                ul
                    li.loading-place()
                        img.image-loading(:src="imageLoading")
                        span Loading...

            ul.place-pallet(:class="showPalletList")
                li(
                    v-for="place in places.location" :key="place.place_id"
                    :class="place.place_id === placeSelected ? 'selected' : ''"
                )
                    a(@click="pickPlace(place)") {{ place.display_name }}

    template(v-if="!error_require")
        div.desc.tw-text-left(v-if="field.description") {{ field.description }}

    div.desc.tw-text-left(v-else) {{ LANG.INPUT_ERROR_REQUIRE }}
</template>

<script>
import GlobalFormGroup from "../../GlobalFormGroup";
import {reactive} from 'vue';

export default {
    name: "Place",
    components: {GlobalFormGroup},
    props: {
        field: {},

        selected: {
            type: Object
        },

        showLabel: {
            type: Boolean,
            default: true
        }
    },

    data() {
        return {
            placeSearch: '',
            places: {
                location: []
            },
            placeSelected: '',
            loadingAjax: false,
            timeout: false,
            show_pallet: false,

            count_down: 0,
            error_require: false,
        }
    },
    computed: {
        imageLoading() {
            return window.nse_config.assets_url + "assets/image/loading.gif"
        },

        showPalletList() {
            return this.show_pallet ? 'shown' : 'hidden';
        }
    },
    watch: {
        count_down(vl) {
            if (vl > 4) {
                this.count_down = 0;
                if (this.timeout) {
                    clearInterval(this.timeout);
                }
                if (!!this.placeSearch) {
                    this.searchStart();
                } else {
                    this.places.location = [];
                }
            }
        }
    },
    methods: {
        searchMap(e) {
            this.placeSearch = e.target.value
            this.count_down = 0;

            if (this.timeout) {
                clearInterval(this.timeout);
            }
            this.timeout = setInterval(() => {
                this.count_down++;
            }, 100);
        },

        searchStart() {
            this.loadingAjax = true;
            this.places.location = [];
            this.show_pallet = false;

            fetch(nse_config.api_endpoint.api_map_url + "&q=" + this.placeSearch + "&language=" + window.nse_config.language)
                .then((jsonData) => {
                    return jsonData.json()
                })
                .then((res) => {
                    this.loadingAjax = false;
                    this.show_pallet = true;
                    this.places.location = res;
                })
        },

        pickPlace(placeDetail) {
            var v = Object.assign({}, this.field, {
                value: placeDetail.display_name,
                lat: placeDetail.lat,
                lng: placeDetail.lon,
                city: placeDetail.city,
                country: placeDetail.country
            });

            this.placeSearch = placeDetail.display_name;
            this.placeSelected = placeDetail.place_id;
            this.show_pallet = false;

            this.$emit('select', v);
        },

        validPlace() {
            if (!!!this.placeSearch) {
                this.error_require = true;
            }
        }
    },

    mounted() {
        this.placeSearch = this.selected.value ? this.selected.value : ''
    }

}
</script>


<style lang="scss">
.list-place-loading {
    position: relative;

    .image-loading {
        width: 34px;
        display: block;
        margin: auto;
        margin-bottom: 3px;
    }
}

.suggestion-place {
    position: relative;

    .place-pallet {
        &.shown {
            opacity: 1;
            visibility: visible;
        }

        &.hidden {
            opacity: 0;
            visibility: hidden;
        }
    }

    ul {
        position: absolute;
        background-color: #fff;
        padding: 5px 0px;
        box-shadow: 1px 1px 9px rgba(0, 0, 0, 0.2);
        margin: auto;
        list-style: none;
        max-height: 140px;
        overflow: auto;
        width: 100%;
        z-index: 9999;

        a {
            display: block;
            color: #444;
            font-size: 13px;
            padding: 7px 10px;
            cursor: pointer;

            &:hover {
                background-color: #f3f3f3;
            }
        }

        .loading-place {
            text-align: center;
            color: #444;
            padding: 5px 10px;
            font-size: 12px;
            font-style: italic;
        }

        li.selected {
            a {
                font-weight: bold;
            }
        }
    }
}
</style>
